import { render } from "./readEventClub.vue?vue&type=template&id=22c0cb66&scoped=true"
import script from "./readEventClub.vue?vue&type=script&lang=js"
export * from "./readEventClub.vue?vue&type=script&lang=js"

import "./readEventClub.vue?vue&type=style&index=0&id=22c0cb66&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c0cb66"]])

export default __exports__